import { render, staticRenderFns } from "./ExpencesCategories.vue?vue&type=template&id=1faf949c&scoped=true"
import script from "./ExpencesCategories.vue?vue&type=script&lang=js"
export * from "./ExpencesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf949c",
  null
  
)

export default component.exports